module.exports = __webpack_public_path__ + "static/media/mentorSHPECol.97d76dd1.png";